import './../Filter/Filter.scss';
import Component from './TenantListFilter.js';
export default Component;